import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container--fluid" }
const _hoisted_2 = { class: "containerWidth my-5 px-2" }
const _hoisted_3 = { class: "flex justify-between align-center mb-4" }
const _hoisted_4 = { class: "flex justify-end" }
const _hoisted_5 = { class: "threeColumnLayout" }
const _hoisted_6 = { class: "patientColumn" }
const _hoisted_7 = { class: "searchColumn" }
const _hoisted_8 = { class: "resultsColumn resultsContainer" }
const _hoisted_9 = {
  key: 0,
  class: "preloaderContainer"
}
const _hoisted_10 = {
  key: 3,
  class: "emptyState"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkedButton = _resolveComponent("LinkedButton")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_PatientSearch = _resolveComponent("PatientSearch")!
  const _component_SearchSlotsForm = _resolveComponent("SearchSlotsForm")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_ScheduledCards = _resolveComponent("ScheduledCards")!
  const _component_SlotDetails = _resolveComponent("SlotDetails")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "title" }, "Appointment Finder", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_LinkedButton, {
            link: "/",
            text: "Go to Dashboard",
            "mdi-icon": "mdi-view-dashboard",
            type: "primary",
            "icon-size": 18,
            "font-size": 13
          }),
          _createVNode(_component_v_btn, {
            class: "ml-3 my-1",
            color: "#d94554",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$store.dispatch('authLogout'))),
            icon: "",
            size: "small",
            variant: "flat"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                color: "white",
                size: 18
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("mdi-logout", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_PatientSearch, {
            onPatientSelected: _ctx.onPatientSelected,
            onPatientCleared: _ctx.onPatientCleared
          }, null, 8, ["onPatientSelected", "onPatientCleared"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_SearchSlotsForm, {
            onIsLoading: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isSearching = !_ctx.isSearching))
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.isSearching)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_v_progress_circular, {
                  class: "spinner",
                  indeterminate: "",
                  size: 100,
                  width: 4,
                  color: "primary"
                }),
                _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-center mt-3" }, "Searching for slots", -1))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isSearching && _ctx.isSlotsLoaded && !_ctx.selectedSlot)
            ? (_openBlock(), _createBlock(_component_ScheduledCards, {
                key: 1,
                onSlotSelected: _ctx.onSlotSelected
              }, null, 8, ["onSlotSelected"]))
            : _createCommentVNode("", true),
          (!_ctx.isSearching && _ctx.selectedSlot)
            ? (_openBlock(), _createBlock(_component_SlotDetails, {
                key: 2,
                trigger: _ctx.slotSelectionTrigger
              }, null, 8, ["trigger"]))
            : _createCommentVNode("", true),
          (!_ctx.isSearching && !_ctx.isSlotsLoaded && !_ctx.selectedSlot)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_v_icon, {
                  size: "80",
                  color: "#ccc"
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("mdi-calendar-search", -1)
                  ]))]),
                  _: 1
                }),
                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "emptyStateText" }, "Search results will appear here", -1))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}